import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import FilteredList from '../common/FilteredList';

import { selectProfile } from '../../selectors/profile';

import * as Shapes from '../../shapes';

import { selectPlaylistsFilterParams, selectSortOrder } from '../../selectors/filteredList';
import { FormattedMessage, injectIntl } from 'react-intl';
import dataComponent from '../../hoc/dataComponent';
import { compose } from 'redux';
import { messages } from '../messages/Profile';
import stylesFilteredList from '../common/FilteredList.css';
import { loadPlaylistsByFilter } from '../../actions/playlist';
import {
  selectFilteredAndSortedPlaylists,
  selectFilteredAndSortedPlaylistsLoading,
} from '../../selectors/playlist';
import { selectPlaylistActiveFacets, selectPlaylistFilterTopFacets } from '../../selectors/facet';
import PlaylistListItem from '../common/PlaylistListItem';
import { ENTITY_TYPE_PLAYLIST, META_TITLE_PREFIX } from '../../constants';
import * as clientActions from '../../actions/client';
import { getBaseHelmet } from '../../utils/profile';
import * as analyticsActions from '../../actions/analytics';

class ProfilePlaylists extends PureComponent {
  static propTypes = {
    playlists: PropTypes.arrayOf(Shapes.Playlist).isRequired,
    topFacets: PropTypes.object,
    location: PropTypes.object,
    activeFacets: PropTypes.array,
    filterParams: PropTypes.object,
    nextCursor: PropTypes.string,
    loadMore: PropTypes.func,
    sort: PropTypes.string.isRequired,
    currentCursor: PropTypes.string,
    prevCursor: PropTypes.string,
    playlistsAreLoading: PropTypes.bool.isRequired,
    loadAllFacets: PropTypes.func.isRequired,
    analyticsTrack: PropTypes.func.isRequired,
    profileId: PropTypes.string.isRequired,
  };

  static onDataFetch(store, params, location, intl) {
    const state = store.getState();
    const profile = selectProfile(state, params.slug);
    const { name } = profile;
    const title = intl.formatMessage(messages.profilePlaylistsMetaTitle, { name });
    const description = intl.formatMessage(messages.profilePlaylistsMetaDescription, { name });
    store.dispatch(
      clientActions.setHelmet({
        ...getBaseHelmet(profile, location, intl),
        title: META_TITLE_PREFIX + title,
        description,
        canonicalRoute: `/profiles/${params.slug}/recordings`,
        keywords: intl.formatMessage(messages.profileRecordingsMetaKeywords, { name }),
        ogTitle: title,
        ogDescription: description,
        currentCursor: params.cursor,
      })
    );
  }

  onItemClick = ({ content }) => {
    this.props.analyticsTrack('Selected Playlist from Profile', {
      id: content.id,
      profileId: this.props.profileId,
    });
  };

  getEmptyListMessage = () => {
    return (
      <FormattedMessage
        id="filtered-list.no-playlists"
        defaultMessage="No playlists match these criteria."
      />
    );
  };

  renderItem = playlist => {
    return (
      <li className={stylesFilteredList.item} key={playlist.id}>
        <PlaylistListItem playlist={playlist} onClick={this.onItemClick} />
      </li>
    );
  };

  render() {
    const {
      playlists,
      location,
      filterParams,
      topFacets,
      activeFacets,
      nextCursor,
      sort,
      prevCursor,
      currentCursor,
      playlistsAreLoading,
      loadAllFacets,
      loadMore,
    } = this.props;

    return (
      <FilteredList
        contextType="profile"
        contextFacet="Composer"
        location={location}
        items={playlists}
        filterType="playlists"
        shouldRenderSortAndFilter={false}
        shouldRenderPlayAllButton={false}
        topFacets={topFacets}
        activeFacets={activeFacets}
        filterParams={filterParams}
        listIsEmpty={!playlists || playlists.length === 0}
        ignoredFacets={['artist_id']}
        nextCursor={nextCursor}
        prevCursor={prevCursor}
        loadMore={loadMore}
        sort={sort}
        currentCursor={currentCursor}
        isLoading={playlistsAreLoading}
        emptyListMessage={this.getEmptyListMessage()}
        renderFilteredListItem={this.renderItem}
        loadAllFacets={loadAllFacets}
        gridLayout
      />
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { slug, cursor } = ownProps.params;
  const profile = selectProfile(state, slug);
  const query = ownProps.location.query;
  const filterParams = selectPlaylistsFilterParams(query, profile.id);

  return {
    profileId: profile.id.toString(),
    playlists: selectFilteredAndSortedPlaylists(state, filterParams),
    location: ownProps.location,
    filterParams,
    sort: selectSortOrder(query, ENTITY_TYPE_PLAYLIST),
    currentCursor: cursor,

    topFacets: selectPlaylistFilterTopFacets(state),
    activeFacets: selectPlaylistActiveFacets(state),

    playlistsAreLoading: selectFilteredAndSortedPlaylistsLoading(state),
    nextCursor: null,
    prevCursor: null,
  };
}

function fetchData(store, { slug, cursor }, location) {
  const state = store.getState();
  const profile = selectProfile(state, slug);
  const { query } = location;
  const filterParams = selectPlaylistsFilterParams(query, profile.id);

  return [store.dispatch(loadPlaylistsByFilter(filterParams, cursor))];
}

const noop = () => {};
export default compose(
  dataComponent(fetchData),
  connect(mapStateToProps, {
    loadMore: loadPlaylistsByFilter,
    loadAllFacets: noop,
    analyticsTrack: analyticsActions.track,
  }),
  injectIntl
)(ProfilePlaylists);
